module.exports = "/images/GC-Grey Footer-Laptop Illustration.jpg";